<template>
  <WrapWithHint v-if="deleteButtonVisible" class="control" :content="deleteHintText">
    <button
      class="button"
      :class="deleteButtonClasses"
      :disabled="!deleteButtonEnabled"
      @click="modalOpen = true"
    >
      <span class="icon">
        <i class="fa fa-trash-alt"></i>
      </span>
      <span>Delete</span>
    </button>
  </WrapWithHint>

  <!-- Kept outside the v-if so hiding the button doesn't unmount the modal during a deletion. -->
  <BulkDeleteModal
    v-model="modalOpen"
    :entity-label="entityLabel"
    :selected-ids="store.selection"
    :delete-endpoint="deleteEndpoint"
    :note="note"
    @deleted="$emit('deleted', $event)"
    @interrupted="$emit('interrupted')"
  />
</template>

<script setup>
  import { computed, ref } from "vue";

  import WrapWithHint from "./wrap-with-hint.vue";
  import BulkDeleteModal from "./bulk-delete-modal.vue";
  import { useBulkDeleteButton } from "./lib/use-bulk-actions.js";

  const props = defineProps({
    store: { type: Object, required: true },
    entityLabel: { type: String, required: true }, // "ingredient" | "recipe"
    visibleRecords: { type: Array, default: () => [] },
    deleteEndpoint: { type: String, required: true },
    note: { type: String, default: null },
  });

  defineEmits(["deleted", "interrupted"]);

  const modalOpen = ref(false);

  const { deleteButtonVisible, deleteButtonEnabled, deleteHintText, deleteButtonClasses } =
    useBulkDeleteButton({
      store: computed(() => props.store),
      entityLabel: props.entityLabel,
      visibleRecords: computed(() => props.visibleRecords),
    });
</script>
